function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { CurrentCustomerIdSelector } from '../selectors/customer.selectors';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
export var RETRIEVE_ENTITLEMENT_BALANCES = {
  BEGIN: 'RETRIEVE_ENTITLEMENT_BALANCES_BEGIN',
  SUCCESS: 'RETRIEVE_ENTITLEMENT_BALANCES_SUCCESS',
  FAILURE: 'RETRIEVE_ENTITLEMENT_BALANCES_FAILURE'
};
export var retrieveEntitlementBalances = function retrieveEntitlementBalances(groupCode, serviceIdentifier, groupEntitlement) {
  return function (dispatch, getState) {
    var state = getState();
    var customerId = CurrentCustomerIdSelector(state);
    return thunkHelper(dispatch, Object.values(RETRIEVE_ENTITLEMENT_BALANCES), {
      method: 'post',
      url: 'SubscriberManagement/RetrieveEntitlementBalances',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        GroupCode: groupCode,
        GroupEntitlement: groupEntitlement,
        ServiceIdentifier: serviceIdentifier || null
      }
    });
  };
};
export var RESET_GROUPED_ENTITLEMENTS_MODAL_STORE = 'RESET_GROUPED_ENTITLEMENTS_MODAL_STORE';
export var resetGroupedEntitlementsModalStore = function resetGroupedEntitlementsModalStore() {
  return {
    type: RESET_GROUPED_ENTITLEMENTS_MODAL_STORE
  };
};
export var SET_GROUPED_ENTITLEMENTS_SELECTED_TAB = 'SET_GROUPED_ENTITLEMENTS_SELECTED_TAB';
export var setGroupedEntitlementsSelectedTab = function setGroupedEntitlementsSelectedTab(tab) {
  return {
    type: SET_GROUPED_ENTITLEMENTS_SELECTED_TAB,
    payload: tab
  };
};